exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index__notFoundContentWarpper___3GecX {\n  width: 100%;\n  padding-bottom: 48px;\n  background: #fff;\n}\n.index__notFoundContentWarpper___3GecX .index__content___F_uhl {\n  min-height: 800px;\n  background: #fff;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  flex-direction: column;\n}\n.index__notFoundContentWarpper___3GecX .index__content___F_uhl .index__title___3nYSn {\n  font-size: 100px;\n  text-align: center;\n  font-weight: 600;\n}\n.index__notFoundContentWarpper___3GecX .index__content___F_uhl .index__description___30t15 {\n  width: 570px;\n  height: 78px;\n  font-size: 28px;\n  font-weight: 200;\n  text-transform: uppercase;\n  margin-top: 35px;\n  margin-bottom: 35px;\n  color: #4a4a4a;\n  letter-spacing: 1px;\n}\n", ""]);

// exports
exports.locals = {
	"notFoundContentWarpper": "index__notFoundContentWarpper___3GecX",
	"content": "index__content___F_uhl",
	"title": "index__title___3nYSn",
	"description": "index__description___30t15"
};